import type { ActivityEvent, ActivitySender } from "activity-logger";
import { LogMyActivityDocument } from "../../services/api/__generated__/backend_gateway-types";
import { ApiService } from "../../services/api/service";
import { sanitizeActivityEvents } from "./privacy";

export const createActivitySender =
  (apiService: ApiService, customerId: string): ActivitySender =>
  async (events: ActivityEvent[]): Promise<void> => {
    if (events.some((event) => event.client !== customerId)) {
      throw new Error("Activity batch tenant mismatch");
    }

    const safeEvents = sanitizeActivityEvents(events, customerId);
    if (safeEvents.length === 0) return;

    const result = await apiService.getClient().mutate({
      mutation: LogMyActivityDocument,
      variables: { eventsJSON: JSON.stringify(safeEvents) },
      fetchPolicy: "no-cache",
      context: {
        atomicCustomerId: customerId,
        fetchOptions: { keepalive: true },
      },
    });

    if (
      result.errors?.length ||
      result.data?.logMyActivity?.accepted !== safeEvents.length
    ) {
      throw new Error("Activity batch was not accepted");
    }
  };
